import { get, getFile } from "@util/request";
import { aboutUsDataUrl, aboutUsH5DataUrl } from '@common/config';

/** 获取首页信息 */
export const getHomeInfo = () => {
    return get("/api/v1/out/api/index");
}

/** 获取公司简介信息 */
export const getCompanyInfo = () => {
    return get("/api/v1/out/api/company");
}

/** 获取产品列表 */
export const getProductInfo = (params) => {
    return get("/api/v1/out/api/product", params);
}

/** 获取产品详情 */
export const getProductDetail = (params) => {
    return get("/api/v1/out/api/product/info", params);
}

/** 获取新闻列表 */
export const getNewsList = (params) => {
    return get("/api/v1/out/api/news", params);
}

/** 获取新闻详情 */
export const getNewsDetail = (params) => {
    return get("/api/v1/out/api/news/info", params);
}

/** 获取联系方式信息 */
export const getContactInfo = (params) => {
    return get("/api/v1/out/api/address/info", params);
}

/** 获取荣誉证书 */
export const getCertList = (params) => {
    return get("/api/v1/out/api/cert", params);
}

/** 获取发展历程 */
export const getGrowthList = (params) => {
    return get("/api/v1/out/api/develop", params);
}

/** 获取合作伙伴 */
export const getPartnersList = (params) => {
    return get("/api/v1/out/api/partner", params);
}

/** 获取系列详情 */
export const getSeriesDetail = (params) => {
    return get("/api/v1/out/api/series", params);
}

/** 获取关于我们 */
export const getAboutUsInfo = () => {
    return getFile(aboutUsDataUrl());
}

/** 获取关于我们H5 */
export const getAboutUsH5Data = () => {
    return getFile(aboutUsH5DataUrl());
}
